import { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";
import { useSettings } from "@/lib/settings";

export const PayPalPay = ({ booking, onPaid }) => {
  const { t } = useI18n();
  const pp = useSettings()?.paypal;
  const [err, setErr] = useState("");
  if (!pp?.enabled || !pp?.client_id || !booking?.id) return null;
  return (
    <div className="mt-6 rounded-2xl bg-white p-4" data-testid="paypal-section">
      <p className="mb-3 text-sm font-semibold text-ink">{t("pay.or")}</p>
      <PayPalScriptProvider options={{ clientId: pp.client_id, currency: booking.currency || "USD", intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "vertical", shape: "pill", color: "gold", label: "pay" }}
          createOrder={async () => (await api.post(`/bookings/${booking.id}/paypal/order`)).data.id}
          onApprove={async (data) => {
            try {
              await api.post(`/bookings/${booking.id}/paypal/capture`, { order_id: data.orderID });
              onPaid?.();
            } catch (e) { setErr(t("pay.err")); }
          }}
          onError={() => setErr(t("pay.err"))}
        />
      </PayPalScriptProvider>
      {err && <p className="mt-2 text-sm text-[#8f3c20]" data-testid="paypal-error">{err}</p>}
    </div>
  );
};
